import { Injectable } from "@angular/core";
import { AbstractControl, UntypedFormControl, ValidatorFn, Validators } from "@angular/forms";

import { PERIOD_FIELDS, periodLimitAmountValidator } from "../../../validators/period-limit-amount.validator";

import { MinimumDepositLimitConfig } from "./minimum-deposit-limit.config";

@Injectable({
	providedIn: "root",
})
export class MinimumDepositLimitService {
	constructor(private minimumDepositLimitConfig: MinimumDepositLimitConfig) {}

	setMinimumDepositLimit(amountControl: UntypedFormControl | AbstractControl, defaultValidators?: ValidatorFn[]) {
		const minimumLimit = this.getMinimumDepositLimit();
		const { min, minLength } = Validators;
		const depositLimitValidators = [
			minLength(1),
			periodLimitAmountValidator(PERIOD_FIELDS.deposit),
			min(minimumLimit),
		];
		const combinedValidators = defaultValidators
			? [...defaultValidators, ...depositLimitValidators]
			: depositLimitValidators;
		amountControl.setValidators(combinedValidators);
	}

	isMinimumDepositLimitEnabled(): boolean {
		return this.minimumDepositLimitConfig.isMinimumDepositLimitEnabled();
	}

	getMinimumDepositLimit(): number {
		return this.minimumDepositLimitConfig.getDepositLimitMinValue();
	}

	getMinimumDepositLimitThreshold(): number {
		return this.minimumDepositLimitConfig.getDepositLimitMinThresholdValue();
	}
}
